import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';
import { Table } from 'primeng/table';
import { ConfirmationService, ConfirmEventType, MessageService } from 'primeng/api';
import { IDefaultGD, IDefaultDataGD, IDefaultDataAddGD, IDefaultDataUpdateGD } from '../models/defaultGD';
import { GestionDispositivosToolsService } from '../services/gestionDispositivosTools.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
/*import xlsx from 'xlsx/xlsx';*/
import * as FileSaver from 'file-saver';
import { saveAs } from 'file-saver';
import ICredencialUsuario from '../models/credencial';
import { AuthService } from '../services/auth.service';
import { empty } from 'rxjs';

@Component({
  selector: 'app-herram',
  templateUrl: './herram.component.html',
  styleUrls: ['./herram.component.scss']
})

export class HerramComponent {
  @ViewChild('dt1') dt!: Table;
  lstTool: Array<IDefaultDataGD> = [];
  dataGetIt: IDefaultGD = { status: false, data: []};
  loading: boolean = false;
  dspProc: boolean = false;
  ToolForm!: FormGroup;
  texto_operacion: string = '';
  num_operacion: number = 0;
  color_gris_deshabilitadas: string = '#D9D9D9';
  fecha_dia: string = new Date().toLocaleDateString('es-MX', { year: 'numeric', month: '2-digit', day: '2-digit' });

  //Permisos
  user: ICredencialUsuario = {};
  constructor(private router: Router,
    private confirmationService: ConfirmationService, private messageService: MessageService,
    private gestionDispositivosService: GestionDispositivosToolsService,private auth: AuthService) {
      this.cargarInformacionUsuario();
  }

  ngOnInit(): void {
    this.getListaDeHerramienta();
    this.crearFormularioHerramienta();
  }

  cargarInformacionUsuario(){
    this.user = this.auth.user;
  }

  getListaDeHerramienta() {
    this.loading=true;
    this.gestionDispositivosService.getListadoHerramientas().subscribe((resp) => {
      if (resp.status) {
        this.lstTool = resp.data
      }

      this.loading=false;
    },
    (error)=> {
      this.loading=false;
      this.mostrarDialogoInformativoSinInformacion('<b>Error</b> En cargar Listado de Herramientas');
    });
  }

  /*Filtro General para la informacion de tabla*/
  applyFilterGlobal($event: any, stringVal: any) {
    this.dt.filterGlobal(($event.target as HTMLInputElement).value, stringVal);
  }

  crearFormularioHerramienta() {
    this.ToolForm = new FormGroup({
      id: new FormControl(),
      nombre: new FormControl('', [Validators.required],),
      descripcion: new FormControl(),
      id_procs: new FormControl({ value: 0, disabled: true }, [],),
      estado: new FormControl()
    });
  }

  guardarInformacionDeHerramienta() {
    if (this.num_operacion == 1) {
      let data_enviar: IDefaultDataAddGD = {
        name: this.ToolForm.get('nombre')?.value,
        desc: this.ToolForm.get('descripcion')?.value,
        user: this.user.cod == undefined ? '0001' : this.user.cod
      };

      this.gestionDispositivosService.saveHerramienta(data_enviar).subscribe((resp) => {
        if (resp.status) {
          setTimeout(() => {
            this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
            this.ToolForm.reset();
            this.cancelarVentanaModal();
            this.getListaDeHerramienta();
          }, 800);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Error en <Agregar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
        }
      },
        (error) => {
          this.messageService.add({ severity: 'error', summary: 'Error en <Agregar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
        });
    } else
      if (this.num_operacion == 2) {
        let data_enviar: IDefaultDataUpdateGD = {
          id: this.ToolForm.get('id')?.value,
          name: this.ToolForm.get('nombre')?.value,
          desc: this.ToolForm.get('descripcion')?.value,
          user: this.user.cod == undefined ? '0001' : this.user.cod,
          state: this.ToolForm.get('estado')?.value
        };

        this.gestionDispositivosService.editHerramienta(data_enviar).subscribe((resp) => {
          if (resp.status) {
            setTimeout(() => {
              this.messageService.add({ severity: 'success', summary: 'Registro Actualizado', detail: 'La informacion se actualizo de forma correcta' });
              this.ToolForm.reset();
              this.cancelarVentanaModal();
              this.getListaDeHerramienta();
            }, 800);
          } else {
            this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
          }
        },
          (error) => {
            this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
          });
      }
  }

  mostrarModalAgregar() {
    this.cancelarVentanaModal();
    this.num_operacion = 1;
    this.dspProc = true;
    this.texto_operacion = 'Agregar Nueva Herramienta';
  }

  mostrarModalEditar(herramienta: IDefaultDataGD) {
    this.ToolForm.controls['id'].setValue(herramienta.id);
    this.ToolForm.controls['nombre'].setValue(herramienta.nombre);
    this.ToolForm.controls['descripcion'].setValue(herramienta.descripcion);
    this.num_operacion = 2;
    this.dspProc = true;
    this.texto_operacion = 'Editar Herramienta';
  }

  cancelarVentanaModal() {
    this.num_operacion = 0;
    this.dspProc = false;
    this.texto_operacion = '';
    this.ToolForm.reset();
  }

  confirmarEliminar(dataDel: IDefaultDataGD) {
   let estatus_original= dataDel.estado;
    let texto_desactivar: string = dataDel.estado == 0 ? 'DESACTIVAR' : 'ACTIVAR';
    let texto_desactivar_header: string = dataDel.estado == 0 ? 'Desactivar' : 'Activar';
    this.confirmationService.confirm({
      message: 'Esta seguro que desea ' + texto_desactivar + ' el registro del Herramienta ' + dataDel.nombre + '?',
      header: 'Confirmacion de ' + texto_desactivar_header,
      icon: 'pi pi-info-circle',
      accept: () => {
        const data: IDefaultDataUpdateGD = {  id: 0, name: '', desc: '', user: '', state: 0 }
        data.id = dataDel.id
        data.state = dataDel.estado == 1 ? 0 : 1
        data.user = this.user.cod == undefined ? '0001' : this.user.cod,

        this.guardarInformacionDesactivar(data);
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            dataDel.estado = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
            break;
          case ConfirmEventType.CANCEL:
            dataDel.estado = estatus_original;
            this.messageService.add({ key: 'msj', severity: 'warn', summary: 'Cancelado', detail: 'Operación cancelada' });
            break;
        }
      }
    });
  }

  guardarInformacionDesactivar(data: IDefaultDataUpdateGD) {
    this.gestionDispositivosService.desactivarHerramienta(data).subscribe((resp) => {
      if (resp.status) {
        setTimeout(() => {
          this.messageService.add({ severity: 'success', summary: 'Registro Exitoso', detail: 'La informacion se almaceno de forma correcta' });
          this.ToolForm.reset();
          this.cancelarVentanaModal();
          this.getListaDeHerramienta();
        }, 800);
      } else {
        this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
      }
    },
      (error) => {
        this.messageService.add({ severity: 'error', summary: 'Error en <Editar Herramienta>', detail: 'Contacte al Administrador del Sitio' });
      });
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    //var FileSaver = require('file-saver');
    var getYear = new Date().toLocaleDateString('es-MX',{ year: 'numeric'});
    var getMonth = new Date().toLocaleDateString('es-MX',{ month: '2-digit'});
    var getDay = new Date().toLocaleDateString('es-MX',{day: '2-digit'});
    var dateFormat = getYear + "-" + getMonth + "-" + getDay;
    let EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    let EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    saveAs(data, fileName + "_export_" + dateFormat + EXCEL_EXTENSION);

  }

  mostrarDialogoInformativoSinInformacion(mensaje_usuario:string){
    let mensaje_completo = mensaje_usuario + '. <b>Contacte al Administrador.</b>';
    this.confirmationService.confirm({
      message: mensaje_completo,
      header: 'Informativo',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.messageService.add({key: 'msj',severity:'info', summary:'Confirmación', detail:'Usuario informado de la situación.' });
      },
      reject: () => {
        this.messageService.add({key: 'msj',severity:'info', summary:'Confirmación', detail:'Usuario informado de la situación.'});
      },
      key: "sinInformacionDialog"
  });
  }

}
